<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="软件名称">
                  <el-input style="width: 177px;" v-model="queryForm.webName"></el-input>
              </el-form-item>
<!--              <el-form-item label="是否隐藏">-->
<!--                  <el-select-->
<!--                      clearable-->
<!--                      style="width: 177px"-->
<!--                      v-model="queryForm.isHide"-->
<!--                      placeholder="请选择"-->
<!--                      size="small"-->
<!--                  >-->
<!--                      <el-option label="否" :value="0"></el-option>-->
<!--                      <el-option label="是" :value="1"></el-option>-->
<!--                  </el-select>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getApiWebTypeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addApiWebType"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editApiWebType(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteApiWebType(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshApiWebTypeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="apiWebTypeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="webName"
        label="名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="webDescription"
        label="描述"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isHide"
        label="是否隐藏"
      >
          <template slot-scope="scope">
            {{scope.row.isHide == 0 ? '否' : '是'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="typeOrder"
        label="排序"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkApiWebType(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editApiWebType(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteApiWebType(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="apiWebTypeStates[apiWebTypeState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="apiWebType"
          ref="apiWebTypeForm"
          :rules="rules"
          label-width="80px"
          size="small"
        >
          <el-form-item
            label="软件名称"
            prop="webName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiWebType.webName"
              :disabled="apiWebTypeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="软件描述"
            prop="webDescription"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiWebType.webDescription"
              :disabled="apiWebTypeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否隐藏"
            prop="isHide"
          >
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="apiWebType.isHide"
                  :disabled="apiWebTypeState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option label="否" :value="0"></el-option>
                  <el-option label="是" :value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="软件排序"
            prop="typeOrder"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="apiWebType.typeOrder"
              :disabled="apiWebTypeState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="apiWebTypeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetApiWebTypeList();
                    this.getApiWebTypeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetApiWebTypeList();
                    this.getApiWebTypeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     webName: '', //名称
                     webDescription: '', //描述
                     isHide: '', //是否隐藏    0：否  1：是    默认为0
                     typeOrder: '', //排序
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                apiWebTypeState: 'add',
                apiWebTypeStates: {
                    add: '新建接口类型',
                    check: '查看接口类型',
                    edit: '修改接口类型'
                },

                multipleSelection: [],
                apiWebTypeList: [],
                apiWebType: {
                    webName: '', //名称
                    webDescription: '', //描述
                    isHide: 0, //是否隐藏    0：否  1：是    默认为0
                    typeOrder: '', //排序
                },
                btnLoading: false,

                rules: {
                    webName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                    webDescription: [{ required: true, message: '描述不能为空', trigger: 'blur' }],
                    isHide: [{ required: true, message: '是否隐藏不能为空', trigger: 'blur' }],
                    typeOrder: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getApiWebTypeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetApiWebTypeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.apiWebTypeList = [];
            },
            resetDialog() {
                this.apiWebTypeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      webName: '', //名称
                      webDescription: '', //描述
                      isHide: '', //是否隐藏    0：否  1：是    默认为0
                      typeOrder: '', //排序
                };
                this.getApiWebTypeList();
            },
            closeDialog() {
                this.showDialog = false
                this.apiWebType = {
                      webName: '', //名称
                      webDescription: '', //描述
                      isHide: 0, //是否隐藏    0：否  1：是    默认为0
                      typeOrder: '', //排序
                };
            },
            submitForm() {
                if (this.apiWebTypeState == 'add') {
                    this.$refs.apiWebTypeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/biz/apiwebtype/add`,{ ...this.apiWebType }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetApiWebTypeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.apiWebTypeState == 'edit') {
                    this.$refs.apiWebTypeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/biz/apiwebtype/edit`,{ ...this.apiWebType }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetApiWebTypeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addApiWebType() {
                this.showDialog = true;
                this.apiWebTypeState = 'add';
            },
            checkApiWebType(apiWebTypeId) {
                console.log(apiWebTypeId);
                this.currentApiWebTypeId = apiWebTypeId;

                this.getApiWebTypeById();
                this.showDialog = true;
                this.apiWebTypeState = 'check';
            },
            editApiWebType(apiWebTypeId) {
                console.log('apiWebType', apiWebTypeId);
                if (apiWebTypeId) {
                    this.currentApiWebTypeId = apiWebTypeId;
                    this.getApiWebTypeById();
                } else {
                    this.apiWebType = { ...this.apiWebType, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.apiWebTypeState = 'edit';
            },
            deleteApiWebType(apiWebTypeId) {
                let ids = '';
                if (apiWebTypeId) {
                    ids = apiWebTypeId;
                } else {
                    ids = this.multipleSelection.map((apiWebType) => apiWebType.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/biz/apiwebtype/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetApiWebTypeList();
                                this.getApiWebTypeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshApiWebTypeList() {
                this.resetApiWebTypeList();
                this.getApiWebTypeList();
            },
            getApiWebTypeList(query = {}) {
                this.loading = true;
                get(`/biz/apiwebtype/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.apiWebTypeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getApiWebTypeById() {
                get(`/biz/apiwebtype/get`,{ id: this.currentApiWebTypeId }).then((res) =>{
                    if(res.success){
                      this.apiWebType = { ...this.apiWebType, ...res.apiWebType };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportApiWebTypeList() {
                //this.btnLoading = true;
                exprotExcel(`/biz/apiwebtype/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/biz/apiwebtype/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/biz/apiwebtype/importData`,formData);
              this.refreshApiWebTypeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getApiWebTypeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getApiWebTypeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>